import Vue from 'vue'
import Router from 'vue-router'
import Register from './views/login/register.vue';
import Reset from './views/login/reset.vue';
import Main from './views/main/main.vue';
import GameDetail from './views/home/GameDetail';
import IOSDemo from './download/iosdemo.vue';
import GameList from './views/home/GameList';
import Index from './views/home/Index';
import Notice from './views/home/Notice';
import Me from './views/home/Me';
import Kf from './views/home/Kf';
import Recharge from './views/app/Recharge.vue';
import RechargeWeiXin from './views/app/RechargeWeiXin.vue';
import WxJsapi from './views/home/wxjsapi.vue';
import Intro from './views/app/intro.vue';
import BindWx from './views/home/bindwx.vue';
import GameSpeedH5 from './views/app/GameSpeedH5.vue';
import SearchGameList from './views/home/SearchGameList';
import MyGame from './views/home/MyGame.vue';
import AppPassword from './views/home/AppPassword';
import AppAbout from './views/home/AppAbout';
import AppRealName from './views/home/AppRealName';
import AppTel from './views/home/AppTel';
import AppSearch from './views/home/AppSearch.vue';
import DownloadApp from './views/home/DownloadApp.vue';
import ContentDetail from './views/home/ContentDetail.vue';

import GoodsList from './views/trade/GoodsList.vue';
import GoodsDetail from './views/trade/GoodsDetail.vue';
import GoodsAdd from './views/trade/GoodsAdd.vue';
import OrderDetail from './views/trade/OrderDetail.vue';
import MyTrade from './views/trade/MyTrade.vue';
import ContentTemp from './views/home/ContentTemp.vue';

/*import TaoHuaLiGame from './views/dispatch/taohuali.vue';
import XingYouGame from './views/dispatch/xingyou.vue';*/

import HuiwanGame from './views/dispatch/huiwan.vue';
import Test from "./views/test/game";

Vue.use(Router)

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err // 非重复导航错误仍需抛出
    }
  })
}

Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/home/gameList',
      name: 'GameList',
      component: GameList
    },
    {
      path: '/home/kf',
      name: 'Kf',
      component: Kf
    },
    {
      path: '/home/trade',
      name: 'GoodsList',
      component: GoodsList,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/home/myGame',
      name: 'MyGame',
      component: MyGame
    },
    {
      path: '/home/notice',
      name: 'Notice',
      component: Notice
    },
    {
      path: '/home/me',
      name: 'Me',
      component: Me
    },
    {
      path: '/home/password',
      name: 'AppPassword',
      component: AppPassword
    },
    {
      path: '/home/about',
      name: 'AppAbout',
      component: AppAbout
    },
    {
      path: '/home/realName',
      name: 'AppRealName',
      component: AppRealName
    },
    {
      path: '/home/tel',
      name: 'AppTel',
      component: AppTel
    },
    {
      path: '/home/appSearch',
      name: 'AppSearch',
      component: AppSearch,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/home/app',
      name: 'DownloadApp',
      component: DownloadApp
    },
    {
      path: '/home/contentDetail',
      name: 'ContentDetail',
      component: ContentDetail
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/h5/*/*',
      name: 'Main',
      component: Main
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: '/rechargeWeiXin',
      name: 'RechargeWeiXin',
      component: RechargeWeiXin
    },
    {
      path: '/gameInfo/*/*',
      name: 'GameDetail',
      component: GameDetail
    },
    {
      path: '/download/iosGuide',
      name: 'IOSDemo',
      component: IOSDemo,
      meta: {
        title: 'IOS信任指引'
      }
    },
    {
      path: '/wxJsapi',
      name: 'WxJsapi',
      component: WxJsapi,
      meta: {
        title: '微信支付'
      }
    },
    {
      path: '/app/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/bindWeChat',
      name: 'BindWx',
      component: BindWx
    },
    {
      path: '/gameSpeedH5',
      name: 'GameSpeedH5',
      component: GameSpeedH5
    },
    {
      path: '/home/searchGameList',
      name: 'SearchGameList',
      component: SearchGameList
    },
    /*{
      path: '/h5game/taohuali',
      name: 'TaoHuaLiGame',
      component: TaoHuaLiGame
    },
    {
      path: '/h5game/xingyou',
      name: 'XingYouGame',
      component: XingYouGame
    },*/
    {
      path: '/h5game/huiwan',
      name: 'HuiwanGame',
      component: HuiwanGame
    },
    {
      path: '/trade/detail',
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/trade/goodsAdd',
      name: 'GoodsAdd',
      component: GoodsAdd
    },
    {
      path: '/trade/orderDetail',
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '/trade/myTrade',
      name: 'MyTrade',
      component: MyTrade
    },
    {
      path: '/strategy',
      name: 'ContentTemp',
      component: ContentTemp
    },
  ]
})
